<template>
    <div>
        <h2>買取履歴検索</h2>

        <!-- カード検索欄 -->
        <v-container fluid>
            <v-row align="center">
                <v-col class="d-flex" cols="12" sm="4">
                    <v-text-field v-model="card_name" @change="not_registerd = false" label="カード名" clearable></v-text-field>
                </v-col>

                <v-col class="d-flex" cols="12" sm="4">
                    <v-select v-model="card_color" :items="color" @change="not_registerd = false" label="色" clearable></v-select>
                </v-col>

                <v-col class="d-flex" cols="12" sm="4">
                    <v-select v-model="card_lot" :items="lot" @change="not_registerd = false" label="収録弾" clearable></v-select>
                </v-col>

                <v-col class="d-flex" cols="12" sm="4">
                    <v-menu v-model="menu" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-model="buy_date" @change="not_registerd = false" label="買取日" readonly v-bind="attrs" v-on="on" clearable></v-text-field>
                        </template>
                        <v-date-picker v-model="buy_date" @input="menu = false" :day-format="date => new Date(date).getDate()"></v-date-picker>
                    </v-menu>
                </v-col>

                <v-col class="d-flex" cols="12" sm="4">
                    <v-select v-model="buy_method" :items="buy_method_list" @change="not_registerd = false" label="買取方法" clearable></v-select>
                </v-col>

                <v-col class="d-flex" cols="12" sm="4">
                    <v-select v-model="condition" :items="condition_list" @change="not_registerd = false" label="カードの状態" clearable></v-select>
                </v-col>

                <div v-if="not_registerd">この検索条件に該当する買取はありません</div>
                <v-btn block color="primary" elevation="2" @click="searchEntry">検索する</v-btn>
            </v-row>
        </v-container>

        <!-- エントリー一覧表示 -->
        <v-data-table
            :headers="headers"
            :items="entries"
            class="elevation-1"
            no-data-text="データはありません"
        >
            <template v-slot:item.actions="{ item }">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon
                        v-bind="attrs"
                        v-on="on"
                        @click="goEditEntry(item)"
                        >
                        mdi-pencil
                        </v-icon>
                    </template>
                    <span>編集する</span>
                </v-tooltip>
            </template>
        </v-data-table>

        <div>合計金額 {{ sum_price }} 円</div>

    </div>
</template>

<script>
export default {
    data() {
        return {
            menu: false,
            not_registerd: false,
            card_name: null,
            card_color: null,
            card_lot: null,
            buy_date: null,
            buy_method: '',
            condition: '',
            sum_price: 0,
            color: ['赤', '緑', '青', '紫', '黄', '黒'],
            lot: [
                'ブースターパック 新時代の主役 [OP-05]',
                'ブースターパック 謀略の王国 [OP-04]',
                'スタートデッキ ゾロ&サンジ [ST-12]',
                'スタートデッキ Side ウタ [ST-11]',
                'アルティメットデッキ"三船長"集結 [ST-10]',
                '限定商品収録カード',
                'プレミアムブースター ONE PIECE CARD THE BEST【PRB-01】',
                'エクストラブースター メモリアルコレクション【EB-01】',
                'ブースターパック 二つの伝説【OP-08】',
                'ブースターパック 500年後の未来【OP-07】',
                'ブースターパック 双璧の覇者【OP-06】',
                'ブースターパック 強大な敵【OP-03】',
                'ブースターパック 頂上決戦【OP-02】',
                'ブースターパック ROMANCE DAWN【OP-01】',
                'スタートデッキ 黄 シャーロット・カタクリ【ST-20】',
                'スタートデッキ 黒 スモーカー【ST-19】',
                'スタートデッキ 紫 モンキー・D・ルフィ【ST-18】',
                'スタートデッキ 青 ドンキホーテ・ドフラミンゴ【ST-17】',
                'スタートデッキ 緑 ウタ【ST-16】',
                'スタートデッキ 赤 エドワード・ニューゲート【ST-15】',
                'スタートデッキ 3D2Y【ST-14】',
                'アルティメットデッキ 3兄弟の絆【ST-13】',
                'スタートデッキ Side ヤマト【ST-09】',
                'スタートデッキ Side モンキー・D・ルフィ【ST-08】',
                'スタートデッキ ビッグ・マム海賊団【ST-07】',
                'スタートデッキ 海軍【ST-06】',
                'スタートデッキ ONE PIECE FILM edition【ST-05】',
                'スタートデッキ 百獣海賊団【ST-04】',
                'スタートデッキ 王下七武海【ST-03】',
                'スタートデッキ 最悪の世代【ST-02】',
                'スタートデッキ 麦わらの一味【ST-01】',
                'ファミリーデッキセット',
                'プロモーションカード',
            ],
            buy_method_list: ['店舗買取', 'ネット買取', '仕入れ'],
            condition_list: ['S', 'A', 'B', 'C'],
            headers: [
                { text: 'カード名', value: 'card.card_name' },
                { text: '色', value: 'card.color' },
                { text: '収録弾', value: 'card.lot' },
                { text: '買取日', value: 'buy_date' },
                { text: '買取方法', value: 'buy_method' },
                { text: 'カードの状態', value: 'condition' },
                { text: '金額(円)', value: 'buy_price' },
                { text: '数量', value: 'entry_quantity' },
                { value: 'actions' },
            ],
            entries: [],
        }
    },
    methods: {
        searchEntry() {
            var params = {}
            this.sum_price = 0
            params.operated_account = this.$store.getters.getStoreId
            if(this.card_name || this.card_color || this.card_lot || this.buy_date || this.buy_method || this.condition) {
                if(this.card_name){
                    params.card_name = this.card_name
                }
                if(this.card_color){
                    params.card_color = this.card_color
                }
                if(this.card_lot){
                    params.card_lot = this.card_lot
                }
                if(this.buy_date){
                    params.buy_date = this.buy_date
                }
                if(this.buy_method){
                    params.buy_method = this.buy_method
                }
                if(this.condition){
                    params.condition = this.condition
                }
                this.axios
                .get(`${process.env.VUE_APP_API_ORIGIN}/entry/search`, {
                    params
                })
                .then(res => {
                    this.entries = res.data
                    if(!this.entries[0]) {
                        this.not_registerd = true
                    }
                    for(var i=0; i<this.entries.length; i++) {
                        this.sum_price += this.entries[i].total_price
                    }
                })
                .catch(() => {
                    alert(e)
                })
            } else {
                alert('検索条件を入力してください')
            }
        },
        goEditEntry(entry) {
            this.$router.push({
                name: 'EditEntry',
                params: {
                    entry_id: entry.id,
                }
            })
        },
    },
    mounted: function () {
        this.axios
        .get(`${process.env.VUE_APP_API_ORIGIN}/entry/list`, {
            params: { account_id: this.$store.getters.getStoreId }
        })
        .then(res => {
            this.entries = res.data
        })
        .catch(() => {
            alert(e)
        })
    }
}
</script>
